import { render, staticRenderFns } from "./Infographic.vue?vue&type=template&id=1bc4f8a7"
import script from "./Infographic.vue?vue&type=script&lang=js"
export * from "./Infographic.vue?vue&type=script&lang=js"
import style0 from "./Infographic.vue?vue&type=style&index=0&id=1bc4f8a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports